/**
 * @generated SignedSource<<89259436742a2cb70b3c39bc863858de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerformanceOverviewCurrencySelection_currencySelection$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Selectbox_selectBox">;
  readonly " $fragmentType": "PerformanceOverviewCurrencySelection_currencySelection";
};
export type PerformanceOverviewCurrencySelection_currencySelection$key = {
  readonly " $data"?: PerformanceOverviewCurrencySelection_currencySelection$data;
  readonly " $fragmentSpreads": FragmentRefs<"PerformanceOverviewCurrencySelection_currencySelection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PerformanceOverviewCurrencySelection_currencySelection",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Selectbox_selectBox"
    }
  ],
  "type": "SelectBox",
  "abstractKey": null
};

(node as any).hash = "f3f990ede215d973e47c164440bb0ee4";

export default node;
